import { cn } from "@garther/ui/libs";

import { ProfileCheck } from "../profile";
import { Header } from "./header";

interface LayoutProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  className?: string;
}

export function RawLayout({ children, className, requireAuth = false }: LayoutProps) {
  return (
    <ProfileCheck requireAuth={requireAuth}>
      <div className={cn("min-h-screen flex flex-col", className)}>
        <Header />
        {children}
      </div>
    </ProfileCheck>
  );
}

export function Layout({ children, className, requireAuth = false }: LayoutProps) {
  return (
    <RawLayout className={className} requireAuth={requireAuth}>
      <div className="flex flex-col items-stretch justify-center p-2 sm:p-3 7xl:px-0 md:p-4 bg-background-primary w-full flex-1">
        <div className="max-w-7xl mx-auto w-full h-full">{children}</div>
      </div>
    </RawLayout>
  );
}
